'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Constants
var GECKO_CONSTS = {};

// Activity constants
// GECKO_CONSTS.ACTIVITY_TYPE_ATTENDANCE  = 'attendance';
// GECKO_CONSTS.ACTIVITY_TYPE_CALL        = 'call';
// GECKO_CONSTS.ACTIVITY_TYPE_INTEGRATION = 'activity';
// GECKO_CONSTS.ACTIVITY_TYPE_MESSAGE     = 'message';
// GECKO_CONSTS.ACTIVITY_TYPE_NOTE        = 'note';
// GECKO_CONSTS.ACTIVITY_TYPE_RESPONSE    = 'response';
// GECKO_CONSTS.ACTIVITY_TYPE_SUBSCRIBER  = 'subscriber';

// GECKO_CONSTS.ACTIVITY_ICONS = {};
// GECKO_CONSTS.ACTIVITY_ICONS[GECKO_CONSTS.ACTIVITY_TYPE_ATTENDANCE]  = 'fa-calendar';
// GECKO_CONSTS.ACTIVITY_ICONS[GECKO_CONSTS.ACTIVITY_TYPE_CALL]        = 'fa-phone';
// GECKO_CONSTS.ACTIVITY_ICONS[GECKO_CONSTS.ACTIVITY_TYPE_INTEGRATION] = 'fa-bolt';
// GECKO_CONSTS.ACTIVITY_ICONS[GECKO_CONSTS.ACTIVITY_TYPE_MESSAGE]     = 'fa-envelope';
// //fa-mobile
// GECKO_CONSTS.ACTIVITY_ICONS[GECKO_CONSTS.ACTIVITY_TYPE_NOTE]        = 'fa-comment';
// GECKO_CONSTS.ACTIVITY_ICONS[GECKO_CONSTS.ACTIVITY_TYPE_RESPONSE]    = 'fa-comment';
// GECKO_CONSTS.ACTIVITY_ICONS[GECKO_CONSTS.ACTIVITY_TYPE_SUBSCRIBER]  = 'fa-bullhorn';

// Alert constants
GECKO_CONSTS.ALERT_TYPE_DANGER = 'danger';
GECKO_CONSTS.ALERT_TYPE_INFO = 'info';
GECKO_CONSTS.ALERT_TYPE_SUCCESS = 'success';
GECKO_CONSTS.ALERT_TYPE_WARNING = 'warning';

GECKO_CONSTS.ALERT_CLASSES = {};
GECKO_CONSTS.ALERT_CLASSES[GECKO_CONSTS.ALERT_TYPE_DANGER] = 'alert-danger';
GECKO_CONSTS.ALERT_CLASSES[GECKO_CONSTS.ALERT_TYPE_INFO] = 'alert-info';
GECKO_CONSTS.ALERT_CLASSES[GECKO_CONSTS.ALERT_TYPE_SUCCESS] = 'alert-success';
GECKO_CONSTS.ALERT_CLASSES[GECKO_CONSTS.ALERT_TYPE_WARNING] = 'alert-warning';

// Avatar constants
GECKO_CONSTS.AVATAR_SIZE_LARGE = 'lg';
GECKO_CONSTS.AVATAR_SIZE_SMALL = 'sm';

// Btn constants
GECKO_CONSTS.BTN_TYPE_DANGER = 'danger';
GECKO_CONSTS.BTN_TYPE_DEFAULT = 'default';
GECKO_CONSTS.BTN_TYPE_PRIMARY = 'primary';
GECKO_CONSTS.BTN_TYPE_INFO = 'info';
GECKO_CONSTS.BTN_TYPE_SUCCESS = 'success';
GECKO_CONSTS.BTN_TYPE_WARNING = 'warning';

GECKO_CONSTS.BTN_CLASSES = {};
GECKO_CONSTS.BTN_CLASSES[GECKO_CONSTS.BTN_TYPE_DANGER] = 'btn-danger';
GECKO_CONSTS.BTN_CLASSES[GECKO_CONSTS.BTN_TYPE_DEFAULT] = 'btn-default';
GECKO_CONSTS.BTN_CLASSES[GECKO_CONSTS.BTN_TYPE_PRIMARY] = 'btn-primary';
GECKO_CONSTS.BTN_CLASSES[GECKO_CONSTS.BTN_TYPE_INFO] = 'btn-info';
GECKO_CONSTS.BTN_CLASSES[GECKO_CONSTS.BTN_TYPE_SUCCESS] = 'btn-success';
GECKO_CONSTS.BTN_CLASSES[GECKO_CONSTS.BTN_TYPE_WARNING] = 'btn-warning';

GECKO_CONSTS.BTN_PRESET_ACTIONS = 'actions';
GECKO_CONSTS.BTN_PRESET_ACTIONS_COMPACT = 'actions_compact';
GECKO_CONSTS.BTN_PRESET_ADD = 'add';
GECKO_CONSTS.BTN_PRESET_CLONE = 'clone';
GECKO_CONSTS.BTN_PRESET_CLOSE = 'close';
GECKO_CONSTS.BTN_PRESET_LOGIN = 'login';
GECKO_CONSTS.BTN_PRESET_REMOVE = 'remove';
GECKO_CONSTS.BTN_PRESET_SAVE = 'save';
GECKO_CONSTS.BTN_PRESET_SEND = 'send';

GECKO_CONSTS.BTN_PRESETS = {};
GECKO_CONSTS.BTN_PRESETS[GECKO_CONSTS.BTN_PRESET_ACTIONS] = {
    name: 'Actions',
    icon: 'cogs',
    type: GECKO_CONSTS.BTN_TYPE_PRIMARY
};
GECKO_CONSTS.BTN_PRESETS[GECKO_CONSTS.BTN_PRESET_ACTIONS_COMPACT] = {
    ariaLabel: 'Actions',
    icon: 'cogs'
};
GECKO_CONSTS.BTN_PRESETS[GECKO_CONSTS.BTN_PRESET_ADD] = {
    name: 'Add New',
    icon: 'plus'
};
GECKO_CONSTS.BTN_PRESETS[GECKO_CONSTS.BTN_PRESET_CLOSE] = {
    name: 'Close',
    icon: 'fa-close'
};
GECKO_CONSTS.BTN_PRESETS[GECKO_CONSTS.BTN_PRESET_LOGIN] = {
    name: 'Login',
    icon: 'fa-sign-in',
    type: GECKO_CONSTS.BTN_TYPE_SUCCESS
};
GECKO_CONSTS.BTN_PRESETS[GECKO_CONSTS.BTN_PRESET_REMOVE] = {
    name: 'Remove',
    icon: 'fa-trash-o',
    type: GECKO_CONSTS.BTN_TYPE_DANGER
};
GECKO_CONSTS.BTN_PRESETS[GECKO_CONSTS.BTN_PRESET_SAVE] = {
    name: 'Save',
    icon: 'fa-save',
    type: GECKO_CONSTS.BTN_TYPE_SUCCESS
};
GECKO_CONSTS.BTN_PRESETS[GECKO_CONSTS.BTN_PRESET_SEND] = {
    name: 'Send Invite',
    icon: 'fa-send'
};

GECKO_CONSTS.BTN_SIZE_LG = 'lg';
GECKO_CONSTS.BTN_SIZE_SM = 'sm';

// Dialog constants
GECKO_CONSTS.DIALOG_TYPE_ALERT = 'alert';
GECKO_CONSTS.DIALOG_TYPE_CONFIRM = 'confirm';
GECKO_CONSTS.DIALOG_TYPE_CUSTOM = 'custom';

// Field constants
GECKO_CONSTS.FIELD_TYPE_ADDRESS = 'address';
GECKO_CONSTS.FIELD_TYPE_CHECKBOX = 'checkbox';
GECKO_CONSTS.FIELD_TYPE_COLOR = 'color';
GECKO_CONSTS.FIELD_TYPE_CUSTOM = 'custom';
GECKO_CONSTS.FIELD_TYPE_DATE = 'date';
GECKO_CONSTS.FIELD_TYPE_DISPLAY = 'display';
GECKO_CONSTS.FIELD_TYPE_EMAIL = 'email';
GECKO_CONSTS.FIELD_TYPE_NAME = 'name';
GECKO_CONSTS.FIELD_TYPE_NUMBER = 'number';
GECKO_CONSTS.FIELD_TYPE_PASSWORD = 'password';
GECKO_CONSTS.FIELD_TYPE_RADIO = 'radio';
GECKO_CONSTS.FIELD_TYPE_RICH_TEXT = 'rich_text';
GECKO_CONSTS.FIELD_TYPE_SEARCH = 'search';
GECKO_CONSTS.FIELD_TYPE_SELECT = 'select';
GECKO_CONSTS.FIELD_TYPE_SELECT_CREATE_MULTI = 'select_create_multi';
GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI = 'select_multi';
GECKO_CONSTS.FIELD_TYPE_TELEPHONE = 'tel';
GECKO_CONSTS.FIELD_TYPE_TEXT = 'text';
GECKO_CONSTS.FIELD_TYPE_TEXTAREA = 'textarea';
GECKO_CONSTS.FIELD_TYPE_TITLE = 'title';
GECKO_CONSTS.FIELD_TYPE_TOGGLE = 'toggle';
GECKO_CONSTS.FIELD_TYPE_URL = 'url';

// Label constants
GECKO_CONSTS.LABEL_TYPE_DANGER = 'danger';
GECKO_CONSTS.LABEL_TYPE_DEFAULT = 'default';
GECKO_CONSTS.LABEL_TYPE_PRIMARY = 'primary';
GECKO_CONSTS.LABEL_TYPE_INFO = 'info';
GECKO_CONSTS.LABEL_TYPE_SUCCESS = 'success';
GECKO_CONSTS.LABEL_TYPE_WARNING = 'warning';

GECKO_CONSTS.LABEL_CLASSES = {};
GECKO_CONSTS.LABEL_CLASSES[GECKO_CONSTS.LABEL_TYPE_DANGER] = 'badge-danger';
GECKO_CONSTS.LABEL_CLASSES[GECKO_CONSTS.LABEL_TYPE_DEFAULT] = 'badge-default';
GECKO_CONSTS.LABEL_CLASSES[GECKO_CONSTS.LABEL_TYPE_PRIMARY] = 'badge-primary';
GECKO_CONSTS.LABEL_CLASSES[GECKO_CONSTS.LABEL_TYPE_INFO] = 'badge-info';
GECKO_CONSTS.LABEL_CLASSES[GECKO_CONSTS.LABEL_TYPE_SUCCESS] = 'badge-success';
GECKO_CONSTS.LABEL_CLASSES[GECKO_CONSTS.LABEL_TYPE_WARNING] = 'badge-warning';

// Modal constants
// GECKO_CONSTS.MODAL_CONFIG_SMALL         = { size: 'sm' };
// GECKO_CONSTS.MODAL_CONFIG_SMALL_LOCKED  = { size: 'sm', backdrop: 'static', keyboard: false };
// GECKO_CONSTS.MODAL_CONFIG_MEDIUM        = { };
// GECKO_CONSTS.MODAL_CONFIG_MEDIUM_LOCKED = { backdrop: 'static', keyboard: false };
// GECKO_CONSTS.MODAL_CONFIG_LARGE         = { size: 'lg' };
// GECKO_CONSTS.MODAL_CONFIG_LARGE_LOCKED  = { size: 'lg', backdrop: 'static', keyboard: false };

// Status constants
GECKO_CONSTS.STATUS_TYPE_DANGER = 'danger';
GECKO_CONSTS.STATUS_TYPE_DEFAULT = 'default';
GECKO_CONSTS.STATUS_TYPE_PRIMARY = 'primary';
GECKO_CONSTS.STATUS_TYPE_INFO = 'info';
GECKO_CONSTS.STATUS_TYPE_SUCCESS = 'success';
GECKO_CONSTS.STATUS_TYPE_WARNING = 'warning';

GECKO_CONSTS.STATUS_CLASSES = {};
GECKO_CONSTS.STATUS_CLASSES[GECKO_CONSTS.STATUS_TYPE_DANGER] = 'badge-danger';
GECKO_CONSTS.STATUS_CLASSES[GECKO_CONSTS.STATUS_TYPE_DEFAULT] = 'badge-default';
GECKO_CONSTS.STATUS_CLASSES[GECKO_CONSTS.STATUS_TYPE_PRIMARY] = 'badge-primary';
GECKO_CONSTS.STATUS_CLASSES[GECKO_CONSTS.STATUS_TYPE_INFO] = 'badge-info';
GECKO_CONSTS.STATUS_CLASSES[GECKO_CONSTS.STATUS_TYPE_SUCCESS] = 'badge-success';
GECKO_CONSTS.STATUS_CLASSES[GECKO_CONSTS.STATUS_TYPE_WARNING] = 'badge-warning';

// Table constants
GECKO_CONSTS.TABLE_CELL_TYPE_CURRENCY = 'currency';
GECKO_CONSTS.TABLE_CELL_TYPE_CUSTOM = 'custom';
GECKO_CONSTS.TABLE_CELL_TYPE_DATE = 'date';
GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT = 'default';
GECKO_CONSTS.TABLE_CELL_TYPE_DROPDOWN = 'dropdown';
GECKO_CONSTS.TABLE_CELL_TYPE_NAME = 'name';
GECKO_CONSTS.TABLE_CELL_TYPE_STATUS = 'status';

// Toast constants
GECKO_CONSTS.TOAST_TYPE_ERROR = 'error';
GECKO_CONSTS.TOAST_TYPE_SUCCESS = 'success';
GECKO_CONSTS.TOAST_TYPE_WARNING = 'warning';

GECKO_CONSTS.TOAST_STYLES = {};
GECKO_CONSTS.TOAST_STYLES[GECKO_CONSTS.TOAST_TYPE_ERROR] = {
    icon: 'fa-exclamation-circle',
    class: GECKO_CONSTS.TOAST_TYPE_ERROR
};
GECKO_CONSTS.TOAST_STYLES[GECKO_CONSTS.TOAST_TYPE_SUCCESS] = {
    icon: 'fa-check',
    class: GECKO_CONSTS.TOAST_TYPE_SUCCESS
};
GECKO_CONSTS.TOAST_STYLES[GECKO_CONSTS.TOAST_TYPE_WARNING] = {
    icon: 'fa-exclamation-triangle',
    class: GECKO_CONSTS.TOAST_TYPE_WARNING
};

GECKO_CONSTS.SOUND_TYPE_SEND = 'send';
GECKO_CONSTS.SOUND_TYPE_RECEIVE = 'receive';
GECKO_CONSTS.SOUND_STYLES = {};

GECKO_CONSTS.SOUND_STYLES[GECKO_CONSTS.SOUND_TYPE_SEND] = 'https://audio.geckochat.io/send.mp3';
GECKO_CONSTS.SOUND_STYLES[GECKO_CONSTS.SOUND_TYPE_RECEIVE] = 'https://audio.geckochat.io/receive.mp3';

exports.GECKO_CONSTS = GECKO_CONSTS;